import applogger from '@applogger'
import Vue from 'vue'

const state = () => ({
  lists: {}
})

const actions = {
  load({ state, commit, rootGetters }, payload) {
    payload = {
      page: 0,
      numitems: 15,
      articleCategory: '',
      ...payload
    }

    let key = `${payload.view}--${payload.display}`
    let requrl = `/vuejs/list/${payload.view}/${payload.display}?items_per_page=${payload.numitems}&page=${payload.page}`

    // Calculate if we have the items on the requested page already
    if (payload.view === 'article' && payload.articleCategory !== '') {
      key = `${payload.view}--${payload.display}--${payload.articleCategory}`
      requrl += `&article_category[]=${payload.articleCategory}`
    }

    if (state.lists[key] && Object.keys(state.lists[key]).length >= ((payload.page + 1) * payload.numitems)) {
      return Promise.resolve(true)
    }

    return this.dispatch('loadItemFromRemote', { url: requrl, config: rootGetters.AuthorizedRequestConfig() })
      .then(list => {
        commit('storeListData', { key: key, list: list.data.data })
        return list.data.data
      })
      .catch(e => {
        applogger.error(e.message)
      })
  },
  storeList({ commit }, payload) {
    throw new Error('list action storeList is deprecated.')
    // let key = `/vuejs/list/${payload.view}/${payload.display}`
    // commit('storeListData', {key: key, list: payload.list})
  },
  resetList({ commit }, payload) {
    commit('removeList', `${payload.view}--${payload.display}`)
  },
  resetCache({ commit }) {
    commit('resetCache')
  }
}

const mutations = {
  removeList(state, key) {
    Vue.delete(state.lists, key)
  },
  storeListData(state, data) {
    let listitems = data.list.reduce((acc, item) => {
      return { ...acc, [item.node.nid]: item.node }
    }, {})
    Vue.set(state.lists, data.key, { ...state.lists[data.key], ...listitems })
  },
  resetCache(state) {
    Vue.set(state, 'lists', {})
  }
}

const getters = {
  get: (state) => {
    return function(view, display, options) {
      let key = `${view}--${display}`
      if (typeof options !== 'undefined' && view === 'article' && options.articleCategory !== '') {
        key = `${view}--${display}--${options.articleCategory}`
      }

      if (state.lists[key]) {
        options = {
          page: 0,
          numitems: 15,
          ...options
        }

        let totalPosts = Object.values(state.lists[key]).length
        let sliceStart = (options.page * options.numitems)
        let sliceEnd = (totalPosts > (sliceStart + options.numitems)) ? (sliceStart + options.numitems) : totalPosts

        let sortedSet = Object.values(state.lists[key]).sort((a, b) => {
          if (typeof options.sorter === 'function') {
            return options.sorter.call(null, a, b)
          }
          else if (key.substr(0, 22) === 'article--ajax_response') {
            return (a.created > b.created) ? -1 : (a.created < b.created) ? 1 : (a.nid > b.nid) ? -1 : 1
          }
          else {
            return (a < b) ? -1 : (a > b) ? 1 : 0
          }
        })
          .slice(sliceStart, sliceEnd)

        return sortedSet
      }
      else {
        return []
      }
    }
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
